export const SUBMIT_SHIFT = "SUBMIT_SHIFT";
export const SUBMIT_SHIFT_SUCCESS = "SUBMIT_SHIFT_SUCCESS";
export const SHIFT_API_ERROR = "SHIFT_API_ERROR";